export default "__VITE_ASSET__BglT9Ozl__"